<template>
  <b-modal
    :no-close-on-backdrop="true"
    no-close-on-esc
    size="xl"
    v-model="showModals"
    title="Revenues and Expenses"
    hide-footer
    @hidden="$emit('modal-cancel')"
  >
    <div class="d-flex flex-row justify-content-center gap-buttons mb-2">
      <div v-for="option in button_options" :key="option.value">
        <div v-if="shouldShowButton(option)">
          <b-button
            :variant="
              option.value == active_button ? 'primary' : 'outline-primary'
            "
            @click="handleButtonClick(option.value)"
            :disabled="migration_data.length > 0"
          >
            {{ option.label }}
          </b-button>
        </div>
      </div>
    </div>
    <b-alert
      v-if="this.active_button !== 'royalty_reports'"
      variant="secondary"
      show
    >
      <b-row cols="12" class="mb-1 alert-heading">
        <b-col class="d-flex align-items-center justify-content-between">
          <b-form-checkbox v-model="show_deleted">
            <b>Show Deleted {{ activeLabel }}</b>
          </b-form-checkbox>

          <b-button-group size="sm">
            <!-- <b-button
              size="sm"
              variant="gradient-primary"
              @click="onMigrateStart"
              v-if="!is_migrate"
            >
              Start Migration
            </b-button>
            <b-button
              size="sm"
              variant="gradient-warning"
              @click="onMigrationDocs"
            >
              Docs
            </b-button> -->
          </b-button-group>
        </b-col>
      </b-row>
    </b-alert>

    <!-- Filters shown only if migration is active -->
    <b-row
      v-if="shouldShowMigrationSection"
      class="my-1 d-flex align-items-center"
    >
      <b-col v-if="active_button == 'revenue'" sm="12" md="4" class="mb-1">
        <b-form-group label="Migrate To Right">
          <v-select
            label="right_name"
            :options="rights"
            placeholder="Select Right"
            class="w-100"
            v-model="selectedRight"
            @input="createMessage('Right')"
          />
        </b-form-group>
        <!-- :reduce="(option) => option.right_id" -->
        <!-- v-model="selectedTerritory1" -->
      </b-col>

      <b-col
        v-if="
          active_button != 'royalty_reports' &&
          type === 'royalty_report_territory'
        "
        sm="12"
        md="4"
        class="mb-1"
      >
        <b-form-group label="Migrate To Territory">
          <v-select
            label="territory_name"
            :options="territories"
            placeholder="Select Territory"
            class="w-100"
            v-model="selectedTerritory"
            @input="createMessage('Territory')"
          />
        </b-form-group>
        <!-- :reduce="(option) => option.territory_id" -->
        <!-- v-model="selectedTerritory2" -->
      </b-col>

      <b-col sm="12" md="4" class="mb-1 d-flex">
        <b-button
          variant="danger"
          class="mr-2 w-100"
          @click="handleResetMigration"
        >
          Reset
        </b-button>
        <b-button
          :disabled="loading"
          variant="success"
          class="w-100"
          @click="
            () => {
              showModal(
                'Are you sure want to migrate?',
                'save',
                message
                // warning_message
              ).then((value) => {
                if (value) {
                  handleMigrateConfirm();
                }
              });
            }
          "
        >
          <template v-if="loading">
            <b-spinner small />
          </template>
          <template v-else> Confirm </template>
        </b-button>
      </b-col>
    </b-row>

    <b-table
      bordered
      ref="selectableTable"
      :fields="currentFields"
      :items="filteredItems"
      responsive
      :empty-text="'No records found'"
      show-empty
      small
      hover
      style="max-height: 390px"
    >
      <template v-if="!show_deleted" #cell(checkbox)="data">
        <b-form-checkbox
          @change="handleCheckboxClick(data.item)"
          v-model="data.item.selectedForMigration"
        />
      </template>
      <template #cell(sr)="data">
        {{ data.index + 1 }}
      </template>
      <template #cell(date)="data">
        <div class="text-nowrap" v-if="data.item.status != '100'">
          <span>
            Revenue Dt. :
            {{
              data.item.date ? moment(data.item.date).format("DD/MM/YYYY") : ""
            }}<br
          /></span>
          <span v-if="data.item.right_type == '2'">
            Royalty Dt. :
            <b>{{
              data.item.revenue_royalty_date
                ? moment(data.item.revenue_royalty_date).format("DD/MM/YYYY")
                : ""
            }}</b></span
          >
        </div>
        <div class="text-nowrap" v-if="data.item.status == '100'">
          <span>
            Revenue Dt. :
            <flat-pickr
              v-if="data.item.status == '100'"
              :config="{
                ...$flatPickrConfig,
              }"
              placeholder="Revenue Date"
              class="form-control"
              v-model="data.item.date" />

            <span v-else>{{
              data.value ? moment(data.value).format("DD/MM/YYYY") : ""
            }}</span>
            <br
          /></span>
          <span>
            Royalty Dt. :
            <flat-pickr
              v-if="data.item.status == '100'"
              :config="{
                ...$flatPickrConfig,
              }"
              placeholder="Royalty Date"
              class="form-control"
              v-model="data.item.revenue_royalty_date"
            />

            <span v-else>{{
              data.value ? moment(data.value).format("DD/MM/YYYY") : ""
            }}</span>
          </span>
        </div>
      </template>
      <template #cell(share_net)="data">
        <div
          class="text-nowrap"
          v-if="data.item.status != '100' || data.item.inv_number"
        >
          <b>
            {{
              data.item.right_type == "1"
                ? "NA"
                : formatCurrency(data.item.share_net)
            }}</b
          >
        </div>
        <div
          class="text-nowrap"
          v-if="data.item.status == '100' && !data.item.inv_number"
        >
          <b-form-input
            v-model="data.item.boNet"
            placeholder="BO Net"
            type="number"
            v-if="data.item.right_type == '1'"
          ></b-form-input>
          <b-form-input
            v-model="data.item.share_net"
            placeholder="Share Net"
            type="number"
            v-else
          >
          </b-form-input>
        </div>
      </template>
      <template #cell(rentalNet)="data">
        <b>{{
          data.item.right_type == "1"
            ? formatCurrency(data.item.rentalNet)
            : "NA"
        }}</b>
      </template>
      <template #cell(boNet)="data">
        <b>
          {{
            data.item.right_type == "1" ? formatCurrency(data.item.boNet) : "NA"
          }}</b
        >
      </template>
      <template #cell(title)="data">
        {{ data.item.uniqueId }}-
        {{ data.item.title }}
      </template>
      <template #cell(expense_type)="data">
        {{
          data.value == 1
            ? "MG PAID"
            : data.value == 2
            ? "BUMPER PAID"
            : data.value == 3
            ? "OVERAGES PAID"
            : data.value == 4
            ? "DIVERS PAID"
            : data.value == 5
            ? "P&A Expense"
            : data.value == 6
            ? "Less Licensor corridor Paid"
            : data.item.revenueType
        }}
      </template>
      <template #cell(expense_amount)="data">
        <b-form-input
          v-if="data.item.status == '100'"
          id="from"
          v-model="data.item.expense_amount"
          placeholder="Expense Amount"
          type="number"
        />
        <div v-else class="text-nowrap">
          <b>
            <span>{{
              data.value ? formatCurrency(data.value) : "0.00"
            }}</span></b
          >
        </div>
      </template>
      <template #cell(expense_date)="data">
        <flat-pickr
          v-if="data.item.status == '100'"
          :config="{
            ...$flatPickrConfig,
          }"
          placeholder="Revenue Date"
          class="form-control"
          v-model="data.item.expense_date"
        />

        <span v-else>{{
          data.value ? moment(data.value).format("DD/MM/YYYY") : ""
        }}</span>
      </template>
      <template #cell(movie_title)="data">
        <div style="width: 150px">
          {{ data.item.movie_title }}
        </div>
      </template>
      <template #cell(dateFrom)="data">
        {{
          data.value
            ? moment(data.item.dateFrom).format("DD/MM/YYYY") +
              " to " +
              moment(data.item.dateTo).format("DD/MM/YYYY")
            : ""
        }}
      </template>
      <template #cell(balance_to_favor)="data">
        <b>{{ "CHF " + formatCurrency(data.item.balance_to_favor) }}</b>
      </template>

      <template #cell(updatedAt)="data">
        <div style="width: 180px" class="d-flex flex-column">
          <div>
            Time:
            {{
              data.value ? moment(data.value).format("DD/MM/YYYY HH:mm") : ""
            }}
          </div>
          <div>Updated By: {{ data.item.updatedBy_name }}</div>
        </div>
      </template>
      <template v-if="!show_deleted" #cell(action)="data">
        <div class="text-nowrap" v-if="$can('delete', 'royalty_report')">
          <b-badge
            type="submit"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="danger"
            v-if="!show_deleted"
            @click="
              () => {
                showModal(
                  'Are you sure want to delete?',
                  'danger'
                  // message,
                  // warning_message
                ).then((value) => {
                  if (value) {
                    handle_delete(data.item);
                  }
                });
              }
            "
          >
            Delete
          </b-badge>
          <b-badge
            type="submit"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            variant="success"
            v-else
            @click="
              () => {
                showModal(
                  'Are you sure want to revert?',
                  'save'
                  // message,
                  // warning_message
                ).then((value) => {
                  if (value) {
                    handle_revert(data.item);
                  }
                });
              }
            "
          >
            Revert
          </b-badge>
        </div>
      </template>
      <template #cell(actions)="data">
        <b-button
          class="mr-1"
          variant="outline-primary"
          size="sm"
          @click="
            onDownloadRoyalty(
              data.item.royalty_report_document,
              data.item.company
            )
          "
          ><feather-icon
            icon="DownloadIcon"
            size="16"
            style="
              font-weight: 600;
              font-family: Verdana, Geneva, Tahoma, sans-serif;
            "
        /></b-button>
      </template>

      <template #cell(revenue_action)="data">
          <div class="text-nowrap">
            <span
              >Revenue Type:
              {{ data.item.right_type == "1" ? "Theatrical" : "Other" }}</span
            >
            <div v-if="data.item.is_billed == '1'">
              <b-badge v-if="data.item.inv_number" variant="light-primary">
                billed with #inv
                {{ data.item.inv_number }}{{data.item.is_manual_invoice == 1 ? " (Manual)" : ""}}</b-badge
              >
              <b-badge v-else variant="light-primary"> Direct Billing</b-badge>
            </div>
            <div v-else><span>NA</span></div> 
          </div>
        
      </template>
      <template #cell(admission)="data">
        {{
            data.item.right_type == "1" && data.item.addmission
              ? data.item.addmission
              : 0
        }}
      </template>
      <template #cell(revenue_customers)="data">
        <div class="text-nowrap">
            <span
              ><p>Lisensee : {{ data.item.company }}</p>
              <p>Licensor : {{ data.item.licensor_company }}</p></span
            >
          </div>
      </template>

      <
    </b-table>
    <template slot="footer"> </template>
  </b-modal>
</template>

<script>
import { BModal, BButton, BSpinner } from "bootstrap-vue";
import { formatCurrency } from "@/utils/helpers";
import vSelect from "vue-select";
import moment from "moment";
import {
  GetRoyaltyReportDataMultiple,
  GetRoyaltyReportList,
  GenerateRoyaltyReportPDF,
  GetMoviesVendor,
  GetVendorMovies,
  SaveRoyaltyServices,
} from "@/apiServices/RevenueServies";
import {
  GetVendorRevenueData,
  DeleteRevenueById,
  GetExpenseData,
} from "@/apiServices/RevenueServies";
import * as ContractServices from "@/apiServices/ContractServices";
import * as RevenueServices from "@/apiServices/RevenueServies";
import ToastificationContentVue from "@/@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import showModal from "../../components/ModalConfirmation";

export default {
  props: {
    showModals: {
      type: Boolean,
      default: false,
    },
    contract_id: {
      type: [Number, String],
      default: null,
    },
    type: {
      type: String,
      default: "acquisition_contract",
    },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      moment: moment,
      form: {
        contract_id: this.contract_id,
        revenue_data: this.revenue_data,
        expenses_data: [],
      },
      revenue_fields: [
        { key: "sr", label: "SR" },
        { key: "revenue_action", label: "Actions" },
        { key: "title", label: "Movie" },
        { key: "revenue_customers", label: "Customer" },
        { key: "rightIdentifier", label: "Rights" },
        { key: "mainTerritory", label: "Territory" },
        { key: "addmission", label: "Admissions" },
        {
          key: "share_net",
          label: "Share Net (CHF)",
          class: "text-right",
          variant: "danger",
        },
        {
          key: "boNet",
          label: "Bo Net (CHF)",
          variant: "danger",
          class: "text-right",
        },
        {
          key: "rentalNet",
          label: "Rental Net (CHF)",
          variant: "danger",
          class: "text-right",
        },
        { key: "date", label: "Dates (DD/MM/YYYY)" },
        { key: "updatedAt", label: "Last Updated" },
        // { key: "action", class: "text-center", label: "Action" },
      ],
      expenses_fields: [
        { key: "sr", label: "SR", class: "text-center" },
        { key: "company", label: "Licensor", class: "text-left" },
        { key: "movie_unique", label: "Movie UniqueID", class: "text-right" },
        { key: "expense_type", label: "Expense Type", class: "text-left" },
        { key: "territoryParentName", label: "Territory", class: "text-left" },
        { key: "expense_date", label: "Date", class: "text-center" },
        {
          key: "expense_amount",
          label: "Amount(CHF)",
          class: "text-right",
          variant: "danger",
        },
        { key: "updatedAt", label: "Last Updated" },
        // { key: "action", class: "text-center", label: "Action" },
      ],
      royalty_report_fields: [
        { key: "sr", label: "Sr" },
        { key: "movie_title", label: "Movie" },
        { key: "dateFrom", label: "Duration" },
        { key: "balance_to_favor", label: "Balance to favor/Unrecouped" },
        { key: "actions", label: "Action" },
      ],
      button_options: [
        { label: "Revenue", value: "revenue" },
        { label: "Expenses", value: "expenses" },
        { label: "Royalty Reports", value: "royalty_reports" },
      ],
      migrate_fields: [
        { key: "checkbox", label: "Migrate" }, // New checkbox column
      ],
      action_fields: [
        { key: "action", class: "text-center", label: "Action" },
      ],
      routerTransition: "zoom-fade",
      routerTransitionOptions: [
        { title: "Zoom Fade", value: "zoom-fade" },
        { title: "Fade", value: "fade" },
        { title: "Slide Fade", value: "slide-fade" },
        { title: "Fade Bottom", value: "fade-bottom" },
      ],
      active_button: "revenue",
      revenue_data: [],
      expenses_data: [],
      royalty_report_data: [],
      show_deleted: false,
      migration_data: [],
      territories: [],
      rights: [],
      selectedTerritory: null,
      selectedRight: null,
      loading: false,
      message: null,
      BASE_URL_FILES: process.env.VUE_APP_FILESURL + '/',
    };
  },
  computed: {
    currentFields() {
      let fields = [];

      if (
        !(this.type == "A" || this.type == "S") &&
        !this.show_deleted &&
        (this.active_button === "revenue" ||
          (this.active_button === "expenses" &&
            this.type === "royalty_report_territory"))
      ) {
        // fields = [...this.migrate_fields];
      }
      switch (this.active_button) {
        case "revenue":
          fields = [...fields, ...this.revenue_fields];
          if(!this.show_deleted && this.$can('delete', 'royalty_report')){
            return [...fields, ...this.action_fields];
          }else{
            return fields;
          }
        case "expenses":
          fields = [...fields, ...this.expenses_fields];
          if(!this.show_deleted && this.$can('delete', 'royalty_report')){
            return [...fields, ...this.action_fields];
          }else{
            return fields;
          }
        case "royalty_reports":
          return this.royalty_report_fields;
        default:
          return fields;
      }
    },
    currentItems() {
      switch (this.active_button) {
        case "revenue":
          return this.revenue_data;
        case "expenses":
          return this.expenses_data;
        case "royalty_reports":
          return this.royalty_report_data;
        default:
          return [];
      }
    },

    activeLabel() {
      const selected = this.button_options.find(
        (option) => option.value === this.active_button
      );
      return selected ? selected.label : "";
    },

    filteredItems() {
      if (!this.show_deleted || this.active_button == "royalty_reports") {
        return this.currentItems.filter((item) => item.status);
      } else {
        return this.currentItems.filter((item) => !item.status);
      }
    },

    shouldShowMigrationSection() {
      return (
        this.migration_data.length > 0 &&
        (//(this.type === "royalty_report_right" &&
          // this.active_button === "revenue") ||
          (this.type === "royalty_report_territory" &&
            (this.active_button === "revenue" ||
              this.active_button === "expenses")))
      );
    },
  },
  components: {
    BModal,
    BButton,
    vSelect,
    BSpinner,
  },

  watch: {
    contract_id: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchRevenueData(newVal);
          this.fetchExpenseData(newVal);
          this.fetchTerRig(newVal);
          if (this.type != "S") {
            this.fetchRoyaltyReportData(newVal);
          }
        }
      },
    },
    showModals: {
      handler(newVal) {
        if (newVal && this.contract_id) {
          this.fetchRevenueData(this.contract_id);
          this.fetchExpenseData(this.contract_id);
          this.fetchTerRig(this.contract_id);
          if (this.type != "S") {
            this.fetchRoyaltyReportData(this.contract_id);
          }
        }
      },
    },
    selectedRight() {
      this.createMessage();
    },
    selectedTerritory() {
      this.createMessage();
    },
  },

  methods: {
    showModal,
    formatCurrency,
    handleButtonClick(option) {
      this.migration_data = [];
      this.selectedTerritory = null;
      this.selectedRight = null;
      // if (this.is_migrate) return;
      this.active_button = option;
    },
    check_type() {},
    shouldShowButton(option) {
      if (this.type === "S" && option.value === "royalty_reports") return false;
      return true;
    },
    async fetchRevenueData(contract_id) {
      try {
        const payload = {
          contractID: contract_id,
          status: false,
        };
        console.log("payload", payload);
        const response = await GetVendorRevenueData(payload);
        console.log(response.data.data, "fowehfouwieh");
        this.revenue_data = response.data.data.map((item, index) => ({
          ...item,
          selectedForMigration: false,
        }));
      } catch (error) {
        console.error("Error fetching revenue data:", error);
      }
    },
    async fetchExpenseData(contract_id) {
      try {
        const payload = {
          contractID: contract_id,
          status: false,
        };
        // console.log("payload", payload);
        const response = await GetExpenseData(payload);
        // console.log(response,"ffffff")
        this.expenses_data = response.data.data.data;
      } catch (error) {
        console.error("Error fetching expense data:", error);
      }
    },

    async fetchRoyaltyReportData(contract_id) {
      try {
        const payload = {
          reportContractId: contract_id,
          selectedRadio: "all",
          limit: 1000,
          page: 1,
        };
        const response = await GetRoyaltyReportList(payload);
        this.royalty_report_data = response.data.data.data;
        console.log("Royalty Report Data:", this.royalty_report_data);
      } catch (error) {
        console.error("Error fetching royalty report data:", error);
      }
    },

    async fetchTerRig(contract_id) {
      try {
        const payload = {
          contract_id: contract_id,
        };
        const response = await ContractServices.get_contract_territories_rights(
          payload
        );
        // console.log("Territory Rights Data:", response);
        this.territories = response.data.data.territories;
        this.rights = response.data.data.rights;
      } catch (error) {
        console.error("Error fetching territory rights:", error);
      }
    },

    handleCheckboxClick(data) {
      console.log("Checkbox clicked for item:", data);
      data.selectedForMigration = !data.selectedForMigration;
      data.selectedForMigration = !data.selectedForMigration;
      if (data.selectedForMigration) {
        this.migration_data.push(data);
      } else {
        this.migration_data = this.migration_data.filter(
          (item) => item.revenue_data_id !== data.revenue_data_id
        );
      }
      console.log("Migration Data:", this.migration_data);
    },

    async revenue_expense_migrate() {
      try {
        const payload = {
          data: this.migration_data,
          selectedRight: this.selectedRight,
          selectedTerritory: this.selectedTerritory,
          contract_id: this.contract_id,
          type: this.active_button,
        };
        this.loading = true;
        const response = await RevenueServices.migrate_revenue_expense_data(
          payload
        );
        // console.log(response)
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Success",
              icon: "EditIcon",
              variant: "success",
            },
          });
          // this.migration_data = [];
          // this.selectedRight = null;
          // this.selectedTerritory = null;
          this.handleResetMigration();
          this.$emit("modal-cancel");
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Migration failed: " + response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
        console.log("Migration response:", response);
      } catch (error) {
        console.error("Error during migration:", error);
      } finally {
        this.loading = false;
      }
    },

    async handleMigrateConfirm() {
      await this.revenue_expense_migrate();
    },

    handleResetMigration() {
      this.migration_data = [];
      this.selectedRight = null;
      this.selectedTerritory = null;
      if (this.active_button == "revenue") {
        this.revenue_data.forEach((item) => {
          console.log("feheo");
          item.selectedForMigration = false;
        });
        // this.fetchRevenueData(this.contract_id)
      } else if (this.active_button == "expenses") {
        this.expenses_data.forEach((item) => {
          item.selectedForMigration = false;
        });
      }
    },

    createMessage() {
      let message = "";

      if (this.selectedRight) {
        message += `(Rights in the selected ${this.active_button} will get migrated to ${this.selectedRight.right_name}) `;
      }

      if (this.selectedTerritory) {
        message += `(Territory in the selected ${this.active_button} will get migrated to ${this.selectedTerritory.territory_name})`;
      }

      this.message = message.trim();
    },

    async handle_delete(data) {
      try {
        let response;
        if (this.active_button == "revenue") {
          const payload = {
            revenue_data_id: data.revenue_data_id,
            type: "delete",
            data: data,
            setPaymentDate: false,
          };
          response = await RevenueServices.DeleteRevenueById(payload);
        } else {
          const payload = {
            type: 0,
            data: data,
          };
          response = await RevenueServices.DeleteExpense(payload);
        }
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Success",
              icon: "EditIcon",
              variant: "success",
            },
          });
          // this.migration_data = [];
          // this.selectedRight = null;
          // this.selectedTerritory = null;
          this.handleResetMigration();
          this.$emit("modal-cancel");
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Migration failed: " + response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        console.error("Error during Deleting Revenue:", error);
      }
    },

    async handle_revert(data) {
      try {
        let response;
        if (this.active_button == "revenue") {
          const payload = {
            revenue_data_id: data.revenue_data_id,
          };
          response = await RevenueServices.revert_revenue(payload);
        } else {
          const payload = {
            revenue_expense_id: data.revenue_expense_id,
          };
          response = await RevenueServices.revert_expense(payload);
        }
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Success",
              icon: "EditIcon",
              variant: "success",
            },
          });
          // this.migration_data = [];
          // this.selectedRight = null;
          // this.selectedTerritory = null;
          this.handleResetMigration();
          this.$emit("modal-cancel");
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: "Migration failed: " + response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        console.error("Error during Deleting Revenue:", error);
      }
    },
    async onDownloadRoyalty(file, outputFileName) {
      const fileName = this.BASE_URL_FILES + file;
      try {
        const response = await fetch(fileName);
        const blob = await response.blob();
        const url = await URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = outputFileName + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.log({ err });
      }
    },
  },
  async beforeMount() {
    const contract_id = this.$route.params.contract_id;
    // const contract_id = this.contract_id;
    if (
      this.type === "acquisition_contract" ||
      this.type === "sales_contract"
    ) {
      const contract_id = this.$route.params.contract_id;
      // const contract_id = this.contract_id;
      this.form.contract_id = contract_id;
    }
    if (contract_id && !isNaN(contract_id)) {
      this.fetchRevenueData(contract_id);
      this.fetchExpenseData(contract_id);
      this.fetchTerRig(contract_id);
      if (this.type != "S") {
        this.fetchRoyaltyReportData(contract_id);
      }
    }
    console.log("Contract ID:", this.contract_id);
  },
};
</script>

<style scoped>
.gap-buttons > * + * {
  margin-left: 0.5rem;
}
</style>
